import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges, OnDestroy, OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

import _findIndex from 'lodash-es/findIndex';
import _find from 'lodash-es/find';
import _forEach from 'lodash-es/forEach';
import _pick from 'lodash-es/pick';

import { ResourceError } from 'libraries/service/resource/ResourceError';
import { DatatablePriceService } from 'libraries/datatable-price/datatable-price.service';

import { IPriceValues } from 'libraries/price-difference/IPrice-difference';
import {
    EFareType,
    IAirports,
    ICarrier,
    IFareFamilyDictionary,
    IQuote,
    IRule,
    ISegmentInformation,
} from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from 'libraries/interfaces/ILabels';
import { FlightDetailsService, ISectorDataObject } from '../flight-details/flight-details.service';
import { PropalService } from 'app_locobook/service/propal/propal.service';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { AirTripResourceService } from 'libraries/service/resources/airTrip/airTripResource.service';
import { IAirQuotePrice, IAirQuoteRequest, IAirQuoteResponse } from 'libraries/service/resources/airTrip/IAirQuote.interface';
import { MatDialog } from '@angular/material/dialog';
import { TextExportDialogComponent } from 'libraries/component/dialogs/text-export-dialog/text-export-dialog.component';
import { PriceService } from 'app_locobook/service/price.service';
import { ITablePrice } from 'libraries/component/booking-information/components/booking-price-card/ITablePrice';
import {
    BookingPriceCardService
} from 'libraries/component/booking-information/components/booking-price-card/booking-price-card.service';
import { IPrice } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { mergeMap } from 'rxjs/operators';
import { ApiPricingXType } from 'libraries/service/resources/booking/interfaces/ApiSearchParameters';
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { IMenuDetails } from 'libraries/hotel/models/menu-details';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { IaqoboAirPermission } from "app_locobook/shared/iaqobo-air-permission.enum";
import { LanguageService } from "libraries/service/language/language.service";
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { EXRateType, ITotal } from 'libraries/interfaces/ITotal';
import { faAngleDown, faAngleUp, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { EServiceQualityEnum } from "libraries/service/resources/airQuote/airQuoteResource.service";
import { ActionInBookingType, ActionType } from "@afidium/ts-facade";
import { ActionQualityHelperService } from "libraries/service/action-quality-helper/action-quality-helper.service";
import { EPenaltyType } from "app_locobook/shared/exchange/exchange.component";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";
import { ISectorSimile } from "libraries/interfaces/i-sector-simile";
import { PriceSwitcherService } from "libraries/component/tab-navigation/price-switcher.service";
import _cloneDeep from "lodash-es/cloneDeep";

@Component({
    selector: 'booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.scss']
})
export class BookingComponent implements AfterViewInit, OnChanges, OnInit, OnDestroy {
    @Input()
    public bookingItem: IQuote;
    // @Input()
    // public updatedBookingFlightPrices: IPrice[];
    public originalPrices: IPrice[];
    @Input()
    public key: string;
    @Input()
    public airports: IAirports;
    @Input()
    public carriers: ICarrier;
    @Input()
    public selectedJourneys: string[] = [];
    @Input()
    public selectedJourneyKey: string;
    @Input()
    public separator: string;
    @Input()
    public price: any;
    @Input()
    public carrier: any;
    @Input()
    public fareFamilyDictionary: { [key: string]: IFareFamilyDictionary };
    @Input()
    public isOthersFlights: boolean = false;
    @Input()
    public selectedFlight: boolean;
    @Input()
    public originalRequest: any;
    @Input()
    public beginDaysDifference: number;
    @Input()
    public showFlightDetails: boolean[] = [];
    @Input()
    public showAllActions: boolean = true;
    @Input()
    public inline: boolean = true;
    @Input()
    public isInlineSegment: boolean = true;
    @Input()
    public mustEmitPriceWidth: boolean;
    @Input()
    public higherPriceWidth: number;
    @Input()
    public updateSelectedJourneyOnJourneyChange: boolean;
    @Input()
    public useServices: boolean = false;
    @Input()
    public selectSectorMatchFolder: ISectorSimile;

    @Output()
    public onEmitPriceWidth: EventEmitter<number> = new EventEmitter<number>();
    @Output()
    public onLoaded: EventEmitter<void> = new EventEmitter<void>();


    public penaltyTypes: typeof EPenaltyType = EPenaltyType;
    public fareTypes: typeof EFareType = EFareType;
    public showAllFlightDetails: boolean;

    public totalPrice: { cost: number; retail: number; };
    public retailTitle: string = "";

    public hasRetailPrice: boolean = false;
    public showDTPrice: boolean = false;
    public showBestPrice: boolean = false;

    public bestPublicPriceValues: { cost: IPriceValues, retail?: IPriceValues };
    public referenceValues: IPriceValues;
    public bestPublicPrice: IAirQuotePrice;
    public bestPublicQuote: IQuote;
    public displayLoading: boolean = false;
    public errorMessage = {
        bestPrice: null
    };
    public bestPriceError: INotification = {
        active: false,
        type: NotificationType.Error,
    };

    public readonly labels: ILabels = {
        costTotal: Yii.t('wui-iqba-js', "Total achat"),
        retailTotal: Yii.t('wui-iqba-js', "Total vente"),
        cost: Yii.t('wui-iqba-js', "(achat)"),
        retail: Yii.t('wui-iqba-js', "(vente)"),
        priceDetail: Yii.t('wui-iqba-js', "Détail des prix"),
        reference: Yii.t('wui-iqba-js', 'Prix de référence par ADT'),
        exportText: Yii.t('wui-iqba-js', "Itinéraire au format texte"),
        alreadyPresent: Yii.t('wui-iqba-js', "Même itinéraire dans le dossier"),
    };

    public readonly dtLabels: ILabels = {
        title: Yii.t('wui-iqba-js', 'Prix proposé'),
        show: Yii.t('wui-iqba-js', 'Afficher le détail des prix'),
        hide: Yii.t('wui-iqba-js', 'Cacher le détail des prix'),
        button: Yii.t('wui-iqba-js', 'Détail des prix'),
    };

    public readonly bestPriceLabels: ILabels = {
        title: Yii.t('wui-iqba-js', 'Prix public'),
        default: Yii.t('wui-iqba-js', 'Obtenir le meilleur prix public'),
        public: Yii.t('wui-iqba-js', 'Meilleur prix public'),
        loading: Yii.t('wui-iqba-js', 'Demande en cours...'),
    };

    public readonly flightDetailsLabels: ILabels = {
        show: Yii.t('wui-iqba-js', 'Afficher les détails des vols'),
        hide: Yii.t('wui-iqba-js', 'Masquer les détails des vols'),
        close: Yii.t('wui-iqba-js', 'Masquer les détails'),
        button: Yii.t('wui-iqba-js', 'Détails des vols'),
    };

    public readonly permission: typeof IaqoboAirPermission = IaqoboAirPermission;

    public error: ResourceError;

    public tablePrice: ITablePrice;
    public tableBestPrice: ITablePrice;

    public priceDiff: number;
    // @FIXME to delete
    public plus: string = '';

    // For the moment, it seems fixed to EUR
    public currency: string = 'EUR';

    public sectorData: ISectorDataObject;

    public priceNavigation: IMenuDetails[] = [
        {
            code: "cost",
            name: Yii.t('wui-iqba-js', "Prix d'achat"),
            exist: true,
            selected: true,
            permission: "iqba.booking.price.cost.show"
        },
        {
            code: "retail",
            name: Yii.t('wui-iqba-js', "Prix de vente"),
            exist: true,
            selected: false,
            permission: "iqba.booking.price.retail.show"
        },
    ];

    public journeys: ISegmentInformation[] = [];
    public readonly ratingDetailsLabel: string = Yii.t('wui-iqba-js', "Détails YUCANGoo");
    public showRatingDetails: boolean;

    public updatedPull: string;
    public originalWidth: number;
    public isResized: boolean;

    public iconAngleUp: IconDefinition = faAngleUp;
    public iconAngleDown: IconDefinition = faAngleDown;

    public mctNotification: INotification = {
        active: false,
        type: NotificationType.Warning,
    };

    public priceTypes: typeof EXRateType = EXRateType;
    public selectedPrice: EXRateType;
    public hasPriceSwitcher: boolean = false;
    public subscription: Subscription = new Subscription();

    @ViewChild('priceWrapper')
    private priceWrapper: ElementRef;


    constructor(
        protected readonly datatablePriceService: DatatablePriceService,
        protected readonly flightDetailsService: FlightDetailsService,
        protected readonly propalService: PropalService,
        protected readonly errorTracingService: ErrorTracingService,
        protected readonly airTripResource: AirTripResourceService,
        protected readonly priceService: PriceService,
        protected readonly dialog: MatDialog,
        protected readonly bookingPriceCardService: BookingPriceCardService,
        protected readonly permissionResourceService: PermissionResourceService,
        public readonly languageService: LanguageService,
        protected readonly changeDetectorRef: ChangeDetectorRef,
        protected readonly actionQualityHelperService: ActionQualityHelperService,
        protected readonly priceSwitcherService: PriceSwitcherService,
    ) {
    }

    public ngOnInit() {
        this.selectedPrice = this.priceSwitcherService.selectedPrice;
        this.hasPriceSwitcher = this.priceSwitcherService.hasPriceSwitcher;
        if (this.hasPriceSwitcher) {
            this.priceNavigation = this.priceNavigation.map((priceNavigationItem: IMenuDetails): IMenuDetails => {
                priceNavigationItem.selected = priceNavigationItem.code === this.selectedPrice;
                return priceNavigationItem;
            });
            this.onChangeTab( this.selectedPrice);

            this.subscription.add(
                this.priceSwitcherService.selectPriceEvent
                    .subscribe((priceType: EXRateType): void => {
                        this.selectedPrice = priceType;
                        this.priceNavigation = this.priceNavigation.map((priceNavigationItem: IMenuDetails): IMenuDetails => {
                           priceNavigationItem.selected = priceNavigationItem.code === priceType;
                           return priceNavigationItem;
                        });
                        this.onChangeTab(priceType);
                        this.changeDetectorRef.detectChanges();
                    })
            );
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.priceWrapper && changes && changes.higherPriceWidth && changes.higherPriceWidth.currentValue) {
            if (changes.higherPriceWidth.currentValue > this.originalWidth) {
                this.updatedPull = `${changes.higherPriceWidth.currentValue - this.originalWidth}px`;
                this.changeDetectorRef.detectChanges();
            }
        }

        if (changes && changes.bookingItem && changes.bookingItem.currentValue) {
            this.init();
        }
        if (changes?.bookingItem?.currentValue && changes.bookingItem.firstChange) {
            this.originalPrices = this.bookingItem.price;
        }
        /*if (changes?.updatedBookingFlightPrices?.currentValue) {
            this.initTablePrice(this.updatedBookingFlightPrices);
            this.totalPrice.cost = Number(this.tablePrice.values.get("total-cost-guaranteed").get("TOTAL").value) * 100;
            const hasRetail: IPrice = this.updatedBookingFlightPrices.find((updatedPrice: IPrice): boolean => updatedPrice.xType.toLowerCase() ===  "retail");
            if(hasRetail){
                this.totalPrice.retail = Number(hasRetail.total.base?.value ?? 0) + Number(hasRetail.total.fee?.value ?? 0) + Number(hasRetail.total.tax?.value ?? 0) + Number(hasRetail.total.addon?.value ?? 0) + Number(hasRetail.total.surcharge?.value ?? 0);
            }
        if (changes?.updatedBookingFlightPrices?.currentValue !== changes?.updatedBookingFlightPrices?.previousValue && !changes?.updatedBookingFlightPrices?.currentValue) {
            this.init();
        }
        }*/

    }

    public init(): void {
        this.totalPrice = this.priceService.getTotalPrice(this.bookingItem.total);
        if (this.bookingItem.currency) {
            this.currency = this.bookingItem.currency.code;
        }
        this.hasRetailPrice = this.bookingItem.total.some((value: ITotal) => value.xType === EXRateType.retail);
        this.retailTitle = this.hasRetailPrice ? this.priceService.getRetailTitle(this.bookingItem.price) : null;

        if (this.bookingItem.priceDifference && this.price && this.price.value) {
            this.referenceValues = {
                // @ts-ignore
                base: this.price.value,
                // base: +this.bookingItem.total[0].value - +this.bookingItem.priceDifference,
                difference: this.bookingItem.priceDifference,
                currency: this.currency,
                calculateDifference: false,
                calculateSum: false
            };
        }

        if ((!this.selectedJourneys || this.selectedJourneys.length === 0) || this.updateSelectedJourneyOnJourneyChange) {
            this.selectedJourneys = (this.selectedJourneys || []);
            this.journeys = [];
            let i: number = 0;
            if (!this.selectedJourneys.length) {
                Object.keys(this.bookingItem.segment).forEach((segmentKey: string) => {
                    this.sectorData = this.flightDetailsService.buildForDetails(
                        // @ts-ignore
                        this.bookingItem.segment,
                        this.propalService.propalResponse.data.dictionary,
                        this.bookingItem.segment[segmentKey].journey
                    );
                    this.selectedJourneys[i] = this.bookingItem.segment[segmentKey].journey[0];
                    i++;
                });
            }
            this.selectedJourneyKey = this.selectedJourneys.join('-');
        }
        this.journeys = [...this.journeys];
        Object.keys(this.bookingItem.segment).forEach((segmentKey: string, index: number) => { //temp, dev purpose
            this.journeys[index] = this.bookingItem.segment[segmentKey][this.selectedJourneys[index]];
        });
        this.initTablePrice();

        if (this.bookingItem.actionArray?.length) {
            this.initQualityAlerts(this.bookingItem.actionArray);
        }

    }


    public ngAfterViewInit(): void {
        if (this.mustEmitPriceWidth) {
            this.originalWidth = this.priceWrapper.nativeElement.offsetWidth;
            if (this.higherPriceWidth && this.higherPriceWidth > this.originalWidth) {
                this.updatedPull = `${this.higherPriceWidth - this.originalWidth}px`;
                this.changeDetectorRef.detectChanges();
            }
            this.onEmitPriceWidth.emit(this.originalWidth);
        }
        this.onLoaded.emit();
    }

    public setBestPrice(): void {
        if (this.showBestPrice) {
            return null;
        }
        this.displayLoading = true;
        this.bestPriceError.active = false;
        const quantity = this.datatablePriceService.getQuantities(this.bookingItem);

        const choosenSegment = buildSectorsFromSegments(this.bookingItem.segment);

        const bookingHost: string = this.bookingItem.host;
        const transactionId: string = this.bookingItem.transactionId;
        const {segment, flexibility, carrier, host, ...request} = this.originalRequest && this.originalRequest.body;

        const source2 = {
            segment: choosenSegment,
            price: {
                fareType: "Public"
            },
            host: bookingHost,
            transactionId
        };

        if (source2.transactionId && source2.transactionId.length < 1) {
            delete source2.transactionId;
        }

        const body: IAirQuoteRequest = {
            quantity,
            // Otherwise use quantities or travellers from the search request
            ...request,
            ...source2
        };

        this.airTripResource.quote(body)
            .pipe(
                mergeMap((result: IAirQuoteResponse) => {
                    this.bestPublicPrice = result.price;
                    if (this.bestPublicPrice) {
                        this.showBestPrice = Boolean(this.bestPublicPrice);
                        this.bestPublicQuote = this.parseQuoteResult(result, this.bookingItem, this.hasRetailPrice);
                        const xType: EXRateType = this.priceNavigation.find((navItem: IMenuDetails): boolean => navItem.selected).code as EXRateType;
                        // this.bestPublicPriceValues = this.getBestPublicPriceValues();
                        // this.bestPublicPriceValues = this.extractBestPublicPrices(
                        //     Array.isArray(result.price) ?
                        //         result.price : [result.price]
                        // );
                        this.bestPublicPriceValues = this.extractBestPublicPrices(this.bestPublicQuote.price as unknown as IAirQuotePrice[]);
                        return this.bookingPriceCardService.constructPriceDataForIQBAQuote(this.bestPublicQuote, xType);
                    }
                    const error: ResourceError = {
                        message: Yii.t('wui-shared-js', "Aucun tarif n'a été trouvé."),
                        name: 'error',
                        status: 404,
                    };
                    this.displayLoading = false;
                    this.bestPriceError = {
                        active: true,
                        message: error.message,
                    };
                    this.changeDetectorRef.markForCheck();
                    this.errorTracingService.captureException(error);
                    return of(null);
                })
            )
            .subscribe({
                    next: (tableBestPrice: ITablePrice): void => {
                        this.displayLoading = false;
                        if (tableBestPrice) {
                            this.tableBestPrice = tableBestPrice;
                        }
                        this.changeDetectorRef.markForCheck();
                    },
                    error: (error: ResourceError): void => {
                        this.displayLoading = false;
                        this.errorMessage.bestPrice = error;
                        this.bestPriceError = {
                            ...this.bestPriceError,
                            active: true,
                            message: error.message,
                        };
                        this.changeDetectorRef.markForCheck();
                        this.errorTracingService.captureException(error);
                    }
                }
            );
    }

    public initTablePrice(updatedPrices?: IPrice[]): void {
        if (!this.hasRetailPrice) {
            this.priceNavigation = this.priceNavigation.filter((item: IMenuDetails) => item.code !== 'retail');
        }
        this.permissionResourceService.getPermissions()
            .pipe(
                mergeMap((permissions: Set<string>): Observable<ITablePrice> => {
                    const xType: EXRateType = permissions.has(this.permission.IQBA_BOOKING_PRICE_COST_SHOW) && permissions.has(this.permission.IQBA_BOOKING_PRICE_RETAIL_SHOW) ?
                        EXRateType.cost :
                        permissions.has(this.permission.IQBA_BOOKING_PRICE_RETAIL_SHOW) ?
                            EXRateType.retail :
                            EXRateType.cost;
                    return this.bookingPriceCardService.constructPriceDataForIQBAQuote(this.bookingItem, xType, updatedPrices);
                })
            )
            .subscribe({
                next: (prices: ITablePrice): void => {
                    this.tablePrice = prices;
                },
                error: (error: Error): void => {
                    this.errorTracingService.captureException(error);
                }
            });
    }

    public onChangeTab(xType: EXRateType): void {
        this.priceNavigation = this.priceNavigation.map((navItem: IMenuDetails) => {
            navItem.selected = navItem.code === xType;
            return navItem;
        });
        this.changeTab(xType);
    }
    public emitPriceType(xType:EXRateType): void {
        this.priceSwitcherService.selectPriceEvent.emit(xType);
    }
    public changeTab(xType: EXRateType): void {
        forkJoin(
            this.bookingPriceCardService.constructPriceDataForIQBAQuote(this.bookingItem, xType),
            this.bestPublicQuote ? this.bookingPriceCardService.constructPriceDataForIQBAQuote(this.bestPublicQuote, xType) : of(null)
        )
            .subscribe({
                next: ([initialPrices, bestPrices]: [ITablePrice, ITablePrice]): void => {
                    this.tablePrice = initialPrices;
                    if (bestPrices) {
                        this.tableBestPrice = bestPrices;
                    }

                },
                error: (error: Error): void => {
                    console.error(error)
                }
            });
    }

    public getLuggageIndex(xID: string): any {

        let index: number;

        index = _findIndex(this.bookingItem.luggage.rule, (o: any) => {
            return _find(o.segment, (p: any) => p === xID);
        });

        return index;
    }

    public getLuggages(xId: string): any {
        if (this.bookingItem.luggage) {
            const relatedRules: IRule[] = this.bookingItem.luggage.rule
                .filter((rule: IRule): boolean => {
                    return rule.segment?.includes(xId);
                });
            const outputRules: IRule[] = [];

            relatedRules
                .forEach((rule: IRule, index: number): void => {
                    if (index === 0) {
                        outputRules.push(rule);
                    } else {
                        //avoid the same rule twice
                        const alreadyExistRule: IRule = outputRules
                            .find((outputRule: IRule): boolean => {
                                const sameRule: boolean = outputRule.in === rule.in;
                                const hasBothRestriction: boolean = outputRule.restriction?.length === rule.restriction?.length;
                                const hasSameRestriction: boolean = hasBothRestriction ? outputRule.restriction[0].unit === rule.restriction[0].unit : false;
                                return sameRule && hasSameRestriction;
                            });
                        if (!alreadyExistRule) {
                            outputRules.push(rule);
                        }
                    }
                });
            return outputRules;
        }
        return null;
    }

    public getFlightDetails(journeyId?: string[], index?: number): void {
        // @ts-ignore
        this.sectorData = this.flightDetailsService.buildForDetails(this.bookingItem.segment, this.propalService.propalResponse.data.dictionary, journeyId);
        this.showFlightDetails[index] = !this.showFlightDetails[index];
    }

    public getAllFlightDetails(event: Event, journeyId?: string[]): void {
        event.stopPropagation();
        // @ts-ignore
        this.sectorData = this.flightDetailsService.buildForDetails(this.bookingItem.segment, this.propalService.propalResponse.data.dictionary, journeyId);
        this.showAllFlightDetails = !this.showAllFlightDetails;
    }

    public textExport(event: Event, journeyIds?: string[]): void {
        event.stopPropagation();
        this.dialog.open(TextExportDialogComponent, {
            minWidth: '50%',
            data: this.propalService.getPlainText(
                this.key,
                this.bookingItem,
                Object.keys(this.bookingItem.segment),
                this.selectedJourneys,
            ),
        });
    }

    public toggleDTPrice(event: Event): void {
        event.stopPropagation();
        this.showDTPrice = !this.showDTPrice;
        this.showRatingDetails = false;
    }

    public toggleRatingDetails(event: Event): void {
        event.stopPropagation();
        this.showRatingDetails = !this.showRatingDetails;
        this.showDTPrice = false;
    }

    public isLockSegment(index: number): boolean {
        if (this.selectSectorMatchFolder) {
            let check = this.selectSectorMatchFolder.data.filter(row => row.index === index && row.sameSector === true);
            if (check.length) {
                return (true);
            }
        }
        return (false);
    }

    public getPriceDif(total: IAirTotal): { neg: boolean, value: number } {
        if (this.selectSectorMatchFolder && this.selectSectorMatchFolder.nbSameFlight) {
            let result = total.value - this.totalPrice.cost;
            return ({
                neg: result < 0,
                value: Math.abs(result),
            });
        }
        return ({
            neg: false,
            value: 0,
        });
    }

    private extractBestPublicPrices(pricesArg: IAirQuotePrice[]): { cost: IPriceValues, retail?: IPriceValues } {
        const prices: IAirQuotePrice[] = _cloneDeep(pricesArg);
        const costPrice: IAirQuotePrice = prices.find((price: IAirQuotePrice): boolean => price.xType === EXRateType.cost);
        const retailPrice: IAirQuotePrice = prices.find((price: IAirQuotePrice): boolean => price.xType === EXRateType.retail);

        const cost: IPriceValues = costPrice && costPrice.total && costPrice.total.total ? {
            base: costPrice.total.total.value,
            difference: Number(this.totalPrice.cost),
            currency: costPrice.total.total.currency,
            calculateDifference: true,
            calculateSum: false
        } : null;

        const retail: IPriceValues = retailPrice && retailPrice.total && retailPrice.total.total ? {
            base: retailPrice.total.total.value,
            difference: Number(this.totalPrice.retail),
            currency: retailPrice.total.total.currency,
            calculateDifference: true,
            calculateSum: false
        } : null;

        return {cost, retail};
    }

    private getBestPublicPriceValues(): { cost: IPriceValues, retail?: IPriceValues } {
        const cost: IPriceValues = {
            base: Number(this.bestPublicQuote.total.find((total: ITotal) => total.xType === EXRateType.cost).value),
            difference: Number(this.totalPrice.cost),
            currency: this.bestPublicQuote.total[0].currency,
            calculateDifference: true,
            calculateSum: false
        };
        if (!this.bestPublicQuote.total.find((total: ITotal) => total.xType === EXRateType.retail)) {
            return {cost};
        }
        return {
            cost,
            retail: {
                base: Number(this.bestPublicQuote.total.find((total: ITotal) => total.xType === EXRateType.retail).value),
                difference: Number(this.totalPrice.retail),
                currency: this.bestPublicQuote.total[0].currency,
                calculateDifference: true,
                calculateSum: false
            }
        };
    }

    // TR MOVE TO SEARCH_QUOTE.SERVICE + TEST
    private parseQuoteResult(result: IAirQuoteResponse, initialQuote: IQuote, hasRetailPrice: boolean): IQuote {
        const bestQuoteResult: IAirQuoteResponse = result;

        const originalPrice: IAirQuotePrice = _cloneDeep(bestQuoteResult.price);

        const bestQuotePriceClone: IPrice[] = !Array.isArray(originalPrice) ?
            [{...originalPrice as unknown as IPrice}] :
            [...originalPrice] as unknown as IPrice[];

        const airResponse: IQuote = {
            ...bestQuoteResult as unknown as IQuote,
            traveller: initialQuote.traveller
        };
        const bestQuoteResultPriceMutable: IPrice[] = !Array.isArray(bestQuoteResult.price) ?
            [bestQuoteResult.price as unknown as IPrice] :
            bestQuoteResult.price as unknown as IPrice[];
        const retailTransportationPrice: IPrice[] = hasRetailPrice ?
            this.priceService.getComputedRetailTransportationPrice([...bestQuoteResultPriceMutable], initialQuote.price, this.bookingItem.total) :
            [];
        const externalRetailPrices: IPrice[] = hasRetailPrice ?
            (initialQuote.price || []).filter((price: IPrice) => price.xTarget === "total" && price.xRole !== "transportation") :
            [];
        airResponse.price = [
            ...bestQuotePriceClone,
            ...retailTransportationPrice,
            ...externalRetailPrices
        ];

        airResponse.price = airResponse.price.map((price: IPrice) => {
            if (price.rate && !Array.isArray(price.rate)) {
                price.rate = [price.rate];
            }
            return price;
        });

        airResponse.total = this.priceService.getTotalFromPrices(airResponse.price, hasRetailPrice);
        return airResponse;
    }

    private initQualityAlerts(actionArray: ActionType[]): void {

        const mctAction: ActionInBookingType = this.actionQualityHelperService.extractActionByQualificationForQuotedAvailabilityTrip(actionArray, EServiceQualityEnum.MCT);

        if (mctAction && !mctAction.xMatch && mctAction.textLineArray?.length) {
            this.mctNotification = {
                ...this.mctNotification,
                active: true,
                // @ts-ignore
                messageArray: mctAction.textLineArray,
            };
        }


    }
}

function buildSectorsFromSegments(segments) {
    const neededKeys: string[] = ['begin', 'end', 'carrier', 'flight', 'from', 'to', 'seat', 'sector'];

    const output = {};

    _forEach(segments, (segment: any, segmentKey) => {
        output[segmentKey] = _pick(segment[segment.journey[0]], neededKeys);
    });

    return output;
}


